document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.calculator-results-section');
    if (!container) return;

    // Load data
    const storedData = JSON.parse(sessionStorage.getItem('donationCalculatorData') || '{}');
    
    // Default values if no data (e.g. direct access)
    const data = {
        amount: storedData.amount !== undefined ? parseFloat(storedData.amount) : 0,
        periodicity: storedData.periodicity || 'mensual',
        donorType: storedData.donorType || 'particular', 
        isRecurring: storedData.isRecurring || false
    };

    // Calculate Totals
    let annualFactor = 1;
    let periodText = 'al mes';
    
    if (data.periodicity === 'mensual') {
        annualFactor = 12;
        periodText = 'al mes';
    } else if (data.periodicity === 'trimestral') {
        annualFactor = 4;
        periodText = 'al trimestre';
    } else if (data.periodicity === 'anual') {
        annualFactor = 1;
        periodText = 'al año';
    }

    const totalAnnual = data.amount * annualFactor;

    // Calculate Deduction
    let deduction = 0;
    if (data.donorType === 'particular') {
        if (totalAnnual <= 250) {
            deduction = totalAnnual * 0.80;
        } else {
            deduction = (250 * 0.80) + ((totalAnnual - 250) * (data.isRecurring ? 0.45 : 0.40));
        }
    } else {
        // Business logic
         if (data.isRecurring) {
            deduction = totalAnnual * 0.50; 
        } else {
            deduction = totalAnnual * 0.40;
        }
    }

    const realCost = totalAnnual - deduction;

    // Update DOM
    const els = {
        periodicityText: container.querySelector('.res-periodicity-text'),
        monthlyAmount: container.querySelector('.res-monthly-amount'),
        totalAnnual: container.querySelector('.res-total-annual'),
        deduction: container.querySelector('.res-deduction'),
        realCost: container.querySelector('.res-real-cost'),
        recalculateBtn: document.getElementById('cr-recalculate'),
        
        // Upsell elements
        upsellAmount: container.querySelector('.res-upsell-amount'),
        upsellCost: container.querySelector('.res-upsell-cost'),
        upsellContainer: container.querySelector('.cr-upsell'),
        disclaimer: container.querySelector('.cr-disclaimer'),
        primaryBtn: container.querySelector('.cr-btn-primary')
    };

    if (els.periodicityText) els.periodicityText.textContent = periodText;
    if (els.monthlyAmount) els.monthlyAmount.textContent = `${data.amount.toLocaleString('es-ES')} €`;
    if (els.totalAnnual) els.totalAnnual.textContent = `${totalAnnual.toLocaleString('es-ES')} €`;
    if (els.deduction) els.deduction.textContent = `${deduction.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`; 
    if (els.realCost) els.realCost.textContent = `${realCost.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €/año`;

    if (data.donorType === 'empresa') {
        if (els.disclaimer) {
            els.disclaimer.innerHTML = '* La deducción máxima será del 15% sobre la base imponible para personas jurídicas. <br>Las cantidades que excedan de este límite, podrán aplicarse en los 10 años inmediatos y sucesivos.<br>Esto aplica a fundaciones y asociaciones sujetas a la ley 49/2002. Además, debes tener en cuenta si tu comunidad autónoma está sujeta a un régimen foral particular o si cuenta con deducciones adicionales.';
        }
        if (els.primaryBtn) {
            els.primaryBtn.textContent = 'ÚNETE COMO EMPRESA ALIADA';
            els.primaryBtn.href = '/hazte-socio-empresas/';
        }
        if (els.recalculateBtn) {
            els.recalculateBtn.textContent = 'VOLVER';
        }
    }



    // Upsell Logic
    if (els.upsellContainer) {
        let upsellHTML = '';
        const title = '<p class="cr-upsell-title">¿Sabías que cuanto más ayudas más te devuelven?</p>';
        
        if (data.donorType === 'particular') {
            if (totalAnnual < 250) {
                // Scenario 1: Particular < 250€/year
                const diff = 250 - totalAnnual;
                // Calculate monthly increase needed. If period is annual/trimestral, convert diff to annual then divide by 12 for "message" purposes
                const monthlyIncreaseNeeded = diff / 12;
                // Round up to avoid decimals like 0.33€
                const suggestedMonthlyIncrease = Math.ceil(monthlyIncreaseNeeded);
                
                // Calculate new cost
                // We add this suggested monthly increase to the existing ANNUAL total.
                // New Annual Total = Current Annual + (Suggested Monthly * 12)
                // Wait, logic says "Con xx€ más al mes". 
                // So if I add X€ more per month, my annual total increases by X*12.
                const additionalAnnual = suggestedMonthlyIncrease * 12;
                const newTotalAnnual = totalAnnual + additionalAnnual;
                
                // Calculate cost for this new total
                // Since it's > 250, 1st 250 at 80%, rest at 40% (assuming not recurring for the upsell comparison base, unless isRecurring is true?)
                // Usually upsell assumes standard case unless specifying fidelity.
                // Let's use the current isRecurring status? Or standard 40% for the rest? 
                // The text "A partir de 250€ ... se aplica el 40%". implying base tier.
                
                const deductionFirstTier = 250 * 0.80;
                const deductionRest = (newTotalAnnual - 250) * 0.40; // 40% applied to rest
                const totalDeduction = deductionFirstTier + deductionRest;
                const newRealCost = newTotalAnnual - totalDeduction;

                upsellHTML = `
                    ${title}
                    <p class="cr-upsell-text">
                        A partir de 250 € de aportación anual se aplica el 40%.<br>
                        <span class="cr-upsell-highlight">Con ${suggestedMonthlyIncrease.toLocaleString('es-ES')} € más al mes ya superas la cifra.</span> El total te supondría <span class="res-upsell-cost">${newRealCost.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</span> de coste anual*.<br>
                        Si ya eres socio/a - <a href="/aumenta-tu-cuota/" target="_blank" class="cr-link">Aumenta tu cuota</a>
                    </p>
                `;
            } else {
                // Scenario 2: Particular >= 250€/year
                upsellHTML = `
                    ${title}
                    <p class="cr-upsell-text">
                        Por fidelidad, si las donaciones se mantienen durante 2 años por igual importe o superior a 250 €, la deducción aumenta del 40% al 45%.<br>
                        Si ya eres socio/a - <a href="/aumenta-tu-cuota/" target="_blank" class="cr-link">Aumenta tu cuota</a>
                    </p>
                `;
            }
        } else {
            // Scenario 3: Empresa (Any amount)
            upsellHTML = `
                ${title}
                <p class="cr-upsell-text">
                    <span class="cr-upsell-highlight">Por fidelidad</span>, si las donaciones se mantienen durante 2 años por igual importe o superior, la deducción aumenta al 50%.<br>
                    Puedes aumentar tu aportación con una <a href="/dona-empresas/" target="_blank" class="cr-link">donación puntual</a>.
                </p>
            `;
        }
        
        els.upsellContainer.innerHTML = upsellHTML;
    }
});
